module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"edit":"Редактировать","delete":"Удалить"}}')
  delete Component.options._Ctor
}
